import React from 'react';
import { Box, Paper, Typography, Chip } from '@mui/material';
import {
  Payments as PaymentsIcon,
  Construction as ConstructionIcon,
} from '@mui/icons-material';

const Payroll = () => (
  <Box sx={{
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f1fcf9 0%, #e8f5e9 100%)',
    p: 2.5,
  }}>
    <Paper sx={{
      p: 4,
      borderRadius: 2.5,
      background: 'white',
      border: '1px solid #e8f5e9',
      boxShadow: '0 2px 12px rgba(17, 153, 142, 0.06)',
      textAlign: 'center',
    }}>
      <Box sx={{
        width: 72, height: 72, borderRadius: 2.5,
        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        mx: 'auto', mb: 2,
        boxShadow: '0 6px 18px rgba(17, 153, 142, 0.35)',
      }}>
        <PaymentsIcon sx={{ color: 'white', fontSize: 38 }} />
      </Box>

      <Typography variant="h5" sx={{ fontWeight: 800, color: '#1b5e20', mb: 0.5 }}>
        Payroll
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Monthly payroll runs with SSNIT, PAYE, and net pay computation.
      </Typography>

      <Chip
        icon={<ConstructionIcon sx={{ color: '#b45309 !important', fontSize: 16 }} />}
        label="Coming next — confirm tax brackets to enable"
        sx={{
          bgcolor: '#fff9e6', color: '#b45309',
          fontWeight: 700, border: '1px solid #ffe0a3', borderRadius: 1.5,
        }}
      />

      <Box sx={{ mt: 3, textAlign: 'left', maxWidth: 540, mx: 'auto' }}>
        <Typography variant="subtitle2" sx={{ color: '#1b5e20', fontWeight: 700, mb: 1 }}>
          What this screen will do:
        </Typography>
        <ul style={{ color: '#37474f', lineHeight: 1.8, paddingLeft: 20, margin: 0 }}>
          <li>Create a monthly payroll run for all active employees</li>
          <li>Compute SSNIT (5.5% employee, 13% employer) automatically</li>
          <li>Apply PAYE income tax based on configured brackets</li>
          <li>Apply per-employee one-off deductions / bonuses</li>
          <li>Approve the run (locks it) and mark as paid</li>
          <li>Print individual payslips</li>
        </ul>
      </Box>
    </Paper>
  </Box>
);

export default Payroll;
